import { render, staticRenderFns } from "./OtherHeader.vue?vue&type=template&id=210a0874&scoped=true&"
import script from "./OtherHeader.vue?vue&type=script&lang=js&"
export * from "./OtherHeader.vue?vue&type=script&lang=js&"
import style0 from "./OtherHeader.vue?vue&type=style&index=0&id=210a0874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a0874",
  null
  
)

export default component.exports